export default "__VITE_ASSET__b115721b__"